import { useUser } from '@/context/userContext';
import { SidebarSupportMenu } from '../SidebarSupportMenu/SidebarSupportMenu';
import { OnboardingGuideToggle } from '@/context/OnboardingGuideContext/ui/OnboardingGuideToggle';
import { useCookiesPreferences } from '@/bundle/CookiesBanner/cookiesContext';
import { SidebarFooterWrapper } from './styles';

export const SidebarFooter = () => {
  const { isOpcoRole, isMasterAdminRole, isTrialAdmin } = useUser();
  const { hasFunctionalCookiesConsent } = useCookiesPreferences();
  const isMasterAdminTrialMode = isMasterAdminRole && isTrialAdmin;

  return (
    <SidebarFooterWrapper hasOffset={hasFunctionalCookiesConsent}>
      {!isOpcoRole && <SidebarSupportMenu />}
      {isMasterAdminTrialMode && <OnboardingGuideToggle />}
    </SidebarFooterWrapper>
  );
};
